import { Box, Grid, Switch, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { GroupBar } from './style';

interface Props {
  sameRound: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const GroupRoundBar = ({ sameRound, onChange }: Props) => {
  const { t } = useTranslation();

  return (
    <GroupBar>
      <Box className="round-title">
        <Typography>{t('cpd_enrollment.round.select_group_round_title')}</Typography>
      </Box>
      <Box className="group-button">
        <Switch value={sameRound} onChange={onChange} checked={sameRound} />
        <Typography className="group-button-text">{t('cpd_enrollment.round.select_group_round_button')}</Typography>
      </Box>
    </GroupBar>
  );
};

export default GroupRoundBar;
